import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  IconPercent,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { Percentual, RegularBenefitVariant } from '../../../../../../../typings'
import { ViewProps } from '../../View'
import { messages } from './messages'

type Props = ViewProps & {
  config: Percentual
}

export function PercentualView(props: Props) {
  const { onEdit, onRemove, config } = props

  const { formatPercentual } = useNumbers()

  const handleEdit = () => onEdit(RegularBenefitVariant.Percentual)

  return (
    <Rule onClick={handleEdit}>
      <RuleIcon>
        <IconPercent />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.title}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>{formatPercentual(config.value)}</Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={handleEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
